import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class DisableService {
    private isDisabled: boolean = false;
    show(): void {
        this.isDisabled = true;
    }

    hide(): void {
        this.isDisabled = false;
    }

    getLoadingState(): boolean {
        return this.isDisabled
    }
}
